<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Paramètres du thème')
</script>

<template>
  <q-page flex> Thème </q-page>
</template>
